import { useCallback, useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "../lib/api";
import { Plus, BellRing } from "lucide-react";
import { toast } from "sonner";
import { BulkForm } from "../components/rent/BulkForm";
import { InvoiceForm } from "../components/rent/InvoiceForm";
import { InvoiceTable } from "../components/rent/InvoiceTable";

const sendAllDue = async () => {
  try {
    const r = await api.post(`/rent-invoices/send-due-reminders?days_ahead=3`);
    toast.success(`Reminders: ${r.data.sent} sent, ${r.data.mocked} mocked, ${r.data.errors} errors (out of ${r.data.total_candidates})`);
  } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
};

export default function Rent() {
  const [items, setItems] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [open, setOpen] = useState(false);
  const [bulkOpen, setBulkOpen] = useState(false);

  const load = useCallback(async () => {
    const [a, b] = await Promise.all([api.get("/rent-invoices"), api.get("/tenants")]);
    setItems(a.data); setTenants(b.data);
  }, []);
  useEffect(() => { load().catch(() => {}); }, [load]);

  const noTenants = tenants.length === 0;
  return (
    <div className="space-y-6" data-testid="rent-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">Collect</div>
          <h1 className="font-display text-2xl sm:text-3xl md:text-4xl font-black tracking-tighter">Rent invoices</h1>
        </div>
        <div className="flex gap-2 flex-wrap">
          <button onClick={sendAllDue} data-testid="send-all-reminders-btn"
                  className="bg-slate-100 border border-slate-200 px-4 py-2.5 hover:bg-slate-200 inline-flex items-center gap-2">
            <BellRing className="h-4 w-4" /> Remind all due
          </button>
          <button onClick={() => setBulkOpen(true)} data-testid="bulk-gen-btn" disabled={noTenants}
                  className="bg-slate-900 text-white px-4 py-2.5 hover:bg-slate-800 inline-flex items-center gap-2 disabled:opacity-50">
            <Plus className="h-4 w-4" /> Bulk generate
          </button>
          <button onClick={() => setOpen(true)} data-testid="add-invoice-btn" disabled={noTenants}
                  className="bg-blue-600 text-white px-5 py-2.5 hover:bg-blue-700 inline-flex items-center gap-2 disabled:opacity-50">
            <Plus className="h-4 w-4" /> New invoice
          </button>
        </div>
      </div>

      {noTenants && <div className="bg-orange-50 border border-orange-200 text-orange-800 p-4">Add tenants first.</div>}
      {bulkOpen && <BulkForm onDone={() => { setBulkOpen(false); load(); }} onCancel={() => setBulkOpen(false)} />}
      {open && <InvoiceForm tenants={tenants} onDone={() => { setOpen(false); load(); }} onCancel={() => setOpen(false)} />}

      <div className="bg-white border border-slate-200 overflow-x-auto">
        <InvoiceTable items={items} tenants={tenants} onSaved={load} />
      </div>
    </div>
  );
}
